import React from 'react';
import { BrowserRouter,Routes,Route } from "react-router-dom";
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Form from './routes/Form';
import FormDEV from './routes_dev/Form';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/">
          <Route path="/form">
            <Route path=":hash" element={<Form/>}/>
            <Route path="/form/dev/:hash" element={<FormDEV/>}/>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
